import React, { useEffect, useState } from 'react';
import { FixedBottomBar, HeaderBox } from './mBookListPage';
import ProfileService from "../../Services/Profile";
import i18n from '../../i18n';
import { Avatar, Box, IconButton, Typography } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useTranslation } from 'react-i18next';
import defaultBook from "../../Images/defaultBook.svg";
import SubjectService from "../../Services/Subjects"
import audioIcon from "../../Images/icons3.png";
import articleIcon from "../../svg/articlesHome.svg";
// Helper component for rendering each product section
const FavoriteSection = ({ title, items, totalRecords, itemType, imageKey, onViewAllClick, onItemClick }: any) => {
  const { t } = useTranslation();
  const handleImageError = (e: any) => {
    const target = e.target;
    target.src = defaultBook;
    target.onerror = null;
  };

  if (!items || items.length === 0) {
    return null;
  }

  const isAudioSection = title === t("itemtype_audios_tr") || title === t("itemtype_pravachans_tr");
  const isArticleSection = title === t("itemtype_articles_tr");
  const shouldShowViewAllCard = totalRecords !== undefined && totalRecords > items.length;

  const audioCardStyles = {
    backgroundColor: "white", padding: "8px",
    width: "27vw", height: "38vw", textAlign: "center",
    flex: "0 0 auto", boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'
  } as React.CSSProperties;

  const bookCardStyles = {
    backgroundColor: "white", padding: "8px",
    width: "27vw", height: "46vw", textAlign: "center",
    flex: "0 0 auto", boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'
  } as React.CSSProperties;

  const viewAllCardStyles = {
    backgroundColor: "white", padding: "20px",
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    width: "50vw", justifyContent: 'center',
    alignItems: 'center', cursor: 'pointer'
  } as React.CSSProperties;

  return (
    <div style={{ backgroundColor: 'white', margin: '6px 6px 0 6px', borderRadius: '4px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingRight: '6px' }}>
        <p style={{ fontSize: '20px', color: '#C40233', fontWeight: 600, fontFamily: 'chanakyaUni', margin: 0, paddingTop: 8, paddingLeft: 14 }}>
          {title}
        </p>
        {shouldShowViewAllCard && (
          <div
            style={{
              backgroundColor: "#f97316",
              padding: '5px 10px',
              height: 30,
              borderRadius: 3,
              color: "white",
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontFamily: 'chanakyaUni',
              cursor: 'pointer',
              marginLeft: '10px',
              fontSize: '14px',
              marginTop: '8px'
            }}
            onClick={onViewAllClick}
          >
            {t('view_all_tr')} {totalRecords} {itemType} {t('view_all_suffix_tr')}
          </div>
        )}
      </div>

      <div style={{ display: 'flex', gap: 8, overflowX: 'auto', marginTop: 10, paddingBottom: 10, scrollbarWidth: "none", msOverflowStyle: "none" }}>
        {items.map((item: any, index: number) => (
          isAudioSection ? (
            <div key={index} style={audioCardStyles} onClick={() => onItemClick?.(item)}>
              <div>
                <img src={audioIcon} height={60} width={60} />
              </div>
              <p style={{
                fontWeight: "bold", color: "#4b2e2e", fontSize: "13px", marginTop: "4px",
                display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical",
                overflow: "hidden", textOverflow: "ellipsis", wordBreak: "break-word", margin: 0
              }}>
                {item?.name}
              </p>
            </div>
          ) : isArticleSection ? (
            <div key={index} style={audioCardStyles} onClick={() => onItemClick?.(item)}>
              <div>
                <img src={articleIcon} height={60} width={60} />
              </div>
              <p style={{
                fontWeight: "bold", color: "#4b2e2e", fontSize: "13px", marginTop: "4px",
                display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical",
                overflow: "hidden", textOverflow: "ellipsis", wordBreak: "break-word", margin: 0
              }}>
                {item?.name}
              </p>
            </div>
          ) : (
            <div key={index} style={bookCardStyles} onClick={() => onItemClick?.(item)}>
              <img
                src={item[imageKey] || defaultBook}
                alt={item?.name}
                style={{ width: "21vw", height: "30vw", objectFit: "cover" }}
                onError={handleImageError}
              />
              <p style={{
                fontWeight: "bold", color: "#4b2e2e", fontSize: "14px", marginTop: "4px",
                display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical",
                overflow: "hidden", textOverflow: "ellipsis", wordBreak: "break-word"
              }}>
                {item?.name}
              </p>
            </div>
          )
        ))}

        {shouldShowViewAllCard && (
          <div onClick={onViewAllClick} style={isAudioSection || isArticleSection ? viewAllCardStyles : bookCardStyles}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', textAlign: 'center' }}>
              <Avatar sx={{ bgcolor: '#f97316', width: 35, height: 35 }}>
                <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
              </Avatar>
              <Typography className='mt-2' style={{ fontSize: '14px', color: "#f97316" }}>
                {t('view_all_tr')} {totalRecords} {itemType} {t('view_all_suffix_tr')}
              </Typography>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const MobileFavoriatePage = () => {
  const [booksData, setBooksData] = useState([]);
  const [audioData, setAudioData] = useState([]);
  const [pravachanData, setPravachanData] = useState([]);
  const [articlesData,setArticlesData]=useState([]);
  const [vivekvanis,setVivekVanis]=useState([]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location:any=useLocation();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await SubjectService.getSubjectDataById(location?.state?.subjectId,200);
        const res = await response;
        setBooksData(res?.result?.book || []);
        setAudioData(res?.result?.audio || []);
        setPravachanData(res?.result?.pravachan || []);
        setArticlesData(res?.result?.article || []);
        setVivekVanis(res?.result?.vivekVanis || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [i18n.language]);

  const handleViewAllBooksClick = () => {
    navigate('/books');
  };
  const handleViewAllAudiosClick = () => {
    navigate('/mobileAudioListPage', { state: { type: "audios" } });
  };
  const handleViewAllPravachansClick = () => {
    navigate('/mobileAudioListPage', { state: { type: "pravachans" } });
  };
  const handleViewAllArticlesClick = () => {
    navigate('/mobileArticles');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <HeaderBox>
        <>
          <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}>
            <ArrowBackIosIcon sx={{ color: "white", fontSize: '18px' }} />
          </IconButton>
          <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}>
            <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
          </IconButton>
          <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
            {t("shrihari_tr")}
          </Typography>
          <Typography variant="h6" sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}>
            {t("Subject_tr")}{location?.state?.subjectName ? ` (${location.state.subjectName})` : ""}
          </Typography>
        </>
      </HeaderBox>

      <Box sx={{
        backgroundColor: "#F0F0F0",
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        paddingBottom: '70px' 
      }}>
        <FavoriteSection
          title={t("itemtype_books_tr")}
          items={booksData.slice(0, 12)}
          totalRecords={booksData.length}
          itemType={t('itemtype_books_tr')}
          imageKey="bookThumbPath"
          onViewAllClick={handleViewAllBooksClick}
          onItemClick={(item: any) => navigate(`/books/${item?.slug}`)}
        />
        <FavoriteSection
          title={t("itemtype_audios_tr")}
          items={audioData.slice(0, 12)}
          totalRecords={audioData.length}
          itemType={t('itemtype_audios_tr')}
          imageKey="bookThumbPath"
          onViewAllClick={handleViewAllAudiosClick}
          onItemClick={(item: any) => navigate('/mobileAudioListPage', { state: { type: "audios", audioId: item?.id } })}
        />
        <FavoriteSection
          title={t("itemtype_pravachans_tr")}
          items={pravachanData.slice(0, 12)}
          totalRecords={pravachanData.length}
          itemType={t('itemtype_pravachans_tr')}
          imageKey="bookThumbPath"
          onViewAllClick={handleViewAllPravachansClick}
          onItemClick={(item: any) => navigate('/mobileAudioListPage', { state: { type: "pravachans", audioId: item?.id } })}
        />
        <FavoriteSection
          title={t("itemtype_articles_tr")}
          items={articlesData.slice(0, 12)}
          totalRecords={articlesData.length}
          itemType={t('itemtype_articles_tr')}
          imageKey="articleThumbPath"
          onViewAllClick={handleViewAllArticlesClick}
          onItemClick={(item: any) => navigate('/mobileArticles', { state: { articleId: item?.id } })}
        />
        {/* <FavoriteSection
          title={t("Kalyan_Kalpataru_tr")}
          viewAllText="View All kalpataru"
          items={articlesData}
          imageKey="kalyanKalpataruThumbPath"
          onViewAllClick={handleViewAllBooksClick}
          />
        <FavoriteSection
          title={t("vivek_vani_tr")}
          viewAllText="View all Vivek vanis"
          items={vivekvanis}
          imageKey="vivekVaniThumbPath"
          onViewAllClick={handleViewAllBooksClick}
        /> */}
      </Box>
      {/* <FixedBottomBar /> */}
    </Box>
  );
};

export default MobileFavoriatePage;